<template>
  <div class="activity-record-page common-bg">
    <van-nav-bar fixed title="申请记录" left-arrow @click-left="$router.back()" />
    <div style="height: 46px"></div>

    <div class="filter-bar">
      <div class="filter-item" @click="showPopup">
        <span>{{ timeOptions[timeIndex].text }}</span>
        <van-icon :name="showTime ? 'arrow-up' : 'arrow-down'" size="10" />
      </div>
      <div class="time-dropdown" v-show="showTime">
        <div class="time-grid">
          <div v-for="(opt, idx) in timeOptions" :key="idx"
               class="time-option" :class="{ active: tempTimeIndex === idx }"
               @click="tempTimeIndex = idx">
            {{ opt.text }}
          </div>
        </div>
        <div class="time-btns">
          <button class="time-btn time-btn-cancel" @click="showTime = false">取消</button>
          <button class="time-btn time-btn-confirm" @click="confirmTime">确认</button>
        </div>
      </div>
    </div>

    <div class="record-list" v-if="list.length > 0">
      <div class="record-item" v-for="(item, index) in list" :key="index">
        <div class="record-info">
          <div class="record-title">{{ item.activity_name }}</div>
          <div class="record-time">{{ item.created_at }}</div>
        </div>
        <div class="record-status" :class="'status-' + item.state">{{ statuTypeS[item.state] }}</div>
      </div>
    </div>

    <div class="record-empty" v-else>
      <div class="empty-icon-wrap">
        <img src="/static/image/img_none_sj.avif" class="empty-icon" alt="" />
      </div>
      <div class="empty-text">今日暂无记录，<span class="empty-link">可查看更多</span></div>
    </div>

  </div>
</template>
<script>
export default {
  name: 'activityRecord',
  data() {
    return {
      list: [],
      pageData: {},
      page: 1,
      loading: false,
      showTime: false,
      timeIndex: 0,
      tempTimeIndex: 0,
      statuTypeS: ['待审核', '通过', '拒绝'],
      timeOptions: [
        { text: '今日', value: 0 },
        { text: '昨日', value: 1 },
        { text: '本周', value: 2 },
        { text: '上周', value: 3 },
        { text: '本月', value: 4 },
        { text: '上月', value: 5 },
        { text: '全部', value: 6 },
      ],
    };
  },
  created() {
    // this.getData();
  },
  methods: {
    showPopup() {
      this.tempTimeIndex = this.timeIndex;
      this.showTime = true;
    },
    confirmTime() {
      this.timeIndex = this.tempTimeIndex;
      this.showTime = false;
      this.page = 1;
      this.list = [];
      this.pageData = {};
      // this.getData();
    },
    getData() {
      let that = this;
      let page = that.page;
      if (page > that.pageData.last_page) {
        that.loading = false;
        return;
      }
      that.$parent.showLoading();
      let info = {
        page: that.page,
      };
      that.$apiFun
        .post('/api/activityApplyLog', info)
        .then(res => {
          if (res.code != 200) {
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.pageData = res.data;
            if (that.page == 1) {
              that.list = res.data.data;
            } else {
              let list = JSON.parse(JSON.stringify(that.list));
              res.data.data.forEach(el => {
                list.push(el);
              });
              that.list = list;
            }
            that.page = page + 1;
          }
          that.loading = false;
          that.$parent.hideLoading();
        })
        .catch(res => {
          that.$parent.hideLoading();
          that.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.activity-record-page {
  min-height: 100vh;
  background: #0a0a0a;

  .filter-bar {
    padding: 10px 15px;
    position: relative;

    .filter-item {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 6px 12px;
      background: #1E1F24;
      border-radius: 4px;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
    }

    .time-dropdown {
      position: absolute;
      top: 100%;
      left: 15px;
      right: 15px;
      margin-top: 4px;
      background: #1a1a1a;
      border-radius: 8px;
      padding: 15px;
      z-index: 100;
    }
  }

  .record-list {
    padding: 15px;

    .record-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 15px;
      background: #292A2C;
      border-radius: 8px;
      margin-bottom: 10px;

      .record-info {
        flex: 1;

        .record-title {
          font-size: 14px;
          color: #fff;
          margin-bottom: 5px;
        }

        .record-time {
          font-size: 12px;
          color: #888;
        }
      }

      .record-status {
        font-size: 12px;
        padding: 4px 10px;
        border-radius: 4px;
        white-space: nowrap;

        &.status-0 {
          color: #DFB372;
          background: rgba(223, 179, 114, 0.15);
        }

        &.status-1 {
          color: #52c41a;
          background: rgba(82, 196, 26, 0.15);
        }

        &.status-2 {
          color: #ff4d4f;
          background: rgba(255, 77, 79, 0.15);
        }
      }
    }
  }

  .record-empty {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem 0;

    .empty-icon-wrap {
      width: 3.5rem;
      height: 3.5rem;
      border-radius: 50%;
      background: rgba(255, 255, 255, 0.05);
      display: flex;
      align-items: center;
      justify-content: center;
      margin-bottom: 0.4rem;

      .empty-icon {
        width: 2.5rem;
        height: 2.5rem;
        opacity: 0.5;
      }
    }

    .empty-text {
      font-size: 0.28rem;
      color: #666;

      .empty-link {
        color: #DFB372;
      }
    }
  }
}

.time-dropdown {
  .time-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 10px;
    margin-bottom: 20px;

    .time-option {
      padding: 12px 0;
      text-align: center;
      font-size: 0.3rem;
      color: #fff;
      background: #292A2C;
      border-radius: 6px;
      border: 1px solid transparent;
      cursor: pointer;

      &.active {
        color: #DFB372;
        border-color: #DFB372;
      }
    }
  }

  .time-btns {
    display: flex;
    gap: 10px;

    .time-btn {
      flex: 1;
      padding: 12px 0;
      font-size: 0.3rem;
      border-radius: 6px;
      border: none;
      cursor: pointer;

      &-cancel {
        background: transparent;
        color: #DFB372;
        border: 1px solid #DFB372;
      }

      &-confirm {
        background: #fff;
        color: #1a1a1a;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/activityRecord.vue